import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import { Toaster } from 'react-hot-toast';
import { initSentry, SentryReact } from './utils/sentry';

// Init Sentry as early as possible so we capture errors during boot.
// No-op if REACT_APP_SENTRY_DSN isn't set.
initSentry();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <SentryReact.ErrorBoundary
      fallback={(
        <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
          <div className="bg-white border border-red-200 rounded-lg p-6 max-w-md text-center shadow">
            <h1 className="text-xl font-bold text-red-700 mb-2">Something went wrong</h1>
            <p className="text-gray-600 text-sm mb-4">
              We&apos;ve been notified. Please refresh and try again.
            </p>
            <button
              onClick={() => window.location.reload()}
              className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
            >
              Refresh
            </button>
          </div>
        </div>
      )}
    >
      <AuthProvider>
        <App />
        <Toaster position="top-right" />
      </AuthProvider>
    </SentryReact.ErrorBoundary>
  </React.StrictMode>
);
